import { Box } from "@mui/system";
import { VehicleInspectionTable } from "../component/vehicleInspection/vehicleInspectionTable";
import { Route, Routes } from "react-router-dom";
import { GenericTitleHeader } from "../component/common/GenericTitleHeader";
import useOperationTranslation from "../hooks/useOperationTranslation";
import SectionHeader from "../../../util/component/SectionHeader";

const VehicleInspectionPage = () => {
    const t = useOperationTranslation();
  return (
    <div>
      {" "}
      <Box>
        <Box>
        <SectionHeader
         title={t("vehicleInspection.title") + " " + t("vehicleInspection.titleFirst")}/>
        </Box>
        <Routes>
          <Route path="/" element={<VehicleInspectionTable />} />
        </Routes>
      </Box>
    </div>
  );
};
export default VehicleInspectionPage;
